import React from "react"
import Divider from "@material-ui/core/Divider"

const DividerComponent = props => {
  return <Divider />
}

export default DividerComponent
